module.exports = __webpack_public_path__ + "static/media/ios-aperture.f7015431.svg";